import { api, BASE_URL } from './api'
import { createAuthenticatedEventSource } from './authenticatedEventSource'

export interface StickerDto {
    id?: string | null
    localId: number
    shape: number
}

export interface StickerGroupDto {
    id?: string | null
    name?: string | null
    stickerIds: number[]
}

export interface VinylData {
    id?: string | null
    name?: string | null
    stickers: StickerDto[]
    groups: StickerGroupDto[]
    price: number
    pricePerSticker: number
}


export interface SaveVinylRequest {
    vehicleId: number
    name: string
    stickers: SaveStickerDto[]
    groups: SaveStickerGroupsDto[]
}

export interface SaveStickerGroupsDto {
    id: number
    name: string
    stickerIds: number[]
}

export interface SaveStickerDto {
    id: number
    t: number
    x: number
    y: number
    sx: number
    sy: number
    r: number
    c: string
    z: number
}

export interface FreeroamPointData {
    money: number
    xp: number
}

export class FreeroamService {

    static getInviteSSE(token: string): EventSource {
        return createAuthenticatedEventSource(`${BASE_URL}/freeroam/sse/stream?token=${token}`)
    }

    static async teleport(point: string) {
        api.post<void>('/freeroom/teleport', { point })
    }

    static async getFreeroamPointData() {
        return api.get<FreeroamPointData>('/freeroom/points')
    }

} 